export * from "./uniform-entry-lazy-page.template";
export { UniformEntryLazyPageTemplate as default } from "./uniform-entry-lazy-page.template";
